<template>
	<div class="Support Support-card support-block">

		<div class="vx-row" v-if="support">
			<div class="vx-col w-full ">
				<vx-card class="align-center">
					<div class="order__head">
						<div class="d-flex align-center flex-wrap">
							<div class="order__head-order">
								<b v-if="$route.params.id" class="mr-5">{{ $t('aDiscuss') }} № </b><span
								class="status"> {{
									$route.params.id
								}}</span>
							</div>
							<div class="order__head-status">
								<b class="mr-5">{{ $t('discussStatus') }}</b>
								<span class="status status-warn " v-if="support.status === 1">{{ $t('waitingToAnswer') }}</span>
								<span class="status status-ok " v-if="support.status === 5">{{ $t('answerReceived') }}</span>
								<span class="status status-danger" v-if="support.status === 3 || support.status === 10">{{ $t('isClosed') }}</span>
							</div>
						</div>
						<div v-if="support.status !== 3 && support.status !== 10">
							<vs-button
								class="mr-3 mb-2"
								color="danger"
								@click="openAlert('warning',support.id, changeStatusToClosed)"
							>{{ $t('closeDiscuss') }}</vs-button>
							<vs-button class="mr-3 mb-2" @click="popupActive = true">{{ $t('write') }}</vs-button>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row mt-8">
			<div class="vx-col w-full ">
				<vx-card class="align-center" v-if="support.messages && support.messages.length">
					<div class="messages">
						<template v-for="(message, index) in support.messages">
							<div class="message mb-3" :class="{manager: message.is_support}">
								<vx-card class="align-center">
									<div class="head">
										<div class="d-flex align-center">
											<div v-if="message.user.photo" class="image">
												<img :src="message.user.photo">
												<!--											<img :src="Boolean(message.user.photo)" alt="">-->
											</div>
											<div class="info">
												<b class="name">{{message.user.username}} <span v-if="message.is_support">{{ $t('techSupport') }}</span></b>
												<div class="theme">{{support.title}}</div>
											</div>
										</div>
										<div class="date">
											<b class="created">{{message.created  | moment("DD.MM.YYYY HH:mm")}}</b>
											<div class="created">{{betweenDate(message.created )}}</div>
										</div>
									</div>
									<div class="body">
										{{message.message}}
									</div>
									<div class="files mt-5" v-if="message.files">
										<a :href="file.url" target="_blank" class="file" v-for="file in message.files">
											<div class="icon">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/></svg>
											</div>
											<div class="name">
												{{file.url}}
											</div>
										</a>
									</div>
								</vx-card>
							</div>
						</template>
						<vs-pagination :total="1" v-model="currentx"></vs-pagination>
					</div>
				</vx-card>

			</div>

		</div>
		<vs-popup
			classContent="card-create-appeal"
			:title="$t('writeMessage')"
			class="primary-popup"
			:active.sync="popupActive"
		>
			<div class="form-input mb-3">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<div class="vs-component vs-con-input-label vs-input vs-input-primary custom-primary-focus">
						<label :class="{ 'focused-label': isPopupInputFocused }" class="vs-input--label">{{ $t('discussText') }}*</label>
						<div class="vs-con-input">
						</div>
						<vs-textarea
							:key="'supportCardTextInput' + popupInputCounter"
							v-model="text"
							name="text"
							v-validate="'required|min:3'"
							class="vs-input-primary"
							rows="4"
							@focusin="isPopupInputFocused = true"
							@focusout="isPopupInputFocused = false"
						/>
					</div>
				</div>
				<span v-if="errors.first('text')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="form-input mb-5">
				<vs-upload
					:key="`uploadImageKey${popupActive}`"
					:show-upload-button="false"
					@change="successUpload"
					:text="$t('loadFile')"
					accept=".word,pptx,.pdf"
				/>
			</div>
			<vs-button color="primary" @click="sendMessage">{{ $t('send') }}</vs-button>
			<vs-button @click="popupActive = false" color="#9a9a9a" type="flat">{{ $t('cancel') }}</vs-button>
		</vs-popup>
		<vs-popup
			class="holamundo terminate-popup"
			:title="$t('confirmAction')"
			:active.sync="terminatingPopupActive"
		>
			<p>
				{{ $t('doYouWantToCloseDiscuss') }} <b>№ {{ this.deletedId }}</b>
			</p>
			<div class="vs-popup--button">
				<vs-button
					@click="terminateSupport"
					color="warning"
				>{{ $t('closeDiscuss') }}</vs-button>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import supportMixin from '@/mixins/support';
import notifier from '../../mixins/notifier'

export default {
	mixins: [supportMixin, notifier],
	name: "Card",
	data() {
		return {
			support: {},
			currentx: 1,
			deletedId: null,
			file: [],
			popupActive: false,
			popupInputCounter: 0,
			text: "",
			isPopupInputFocused: false
		}
	},
	watch: {
		popupActive(value) {
			if(value) {
				this.popupInputCounter++;
				this.text = "";
			}
		}
	},
	methods: {
		successUpload(err, file) {
			this.file.push(file[file.length - 1]);
		},
		async uploadFile(file) {
			try {
				const res = await this.$http.post('/upload/one',this.$formData({file: file}));
				return res.data.data.path;

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async sendMessage() {
			try {
				this.$validator.validateAll().then(async result => {
					let files = await Promise.all(this.file.map(async item => await this.uploadFile(item)));

					if (result) {
						let formData = {
							message: this.text,
							files: files,
						}
						let res = (await this.$http.post('/support/send-message/' + this.$route.params.id, formData)).data.data;
						await this.getSupport();

						this.popupActive = false;
						this.text = '';
						this.file = [];
						this.notifySuccess(this.$t('dataIsSaved'));
					}
				});
			} catch (e) {
				this.notifyError(e.message)
			}
		},
		async getSupport(){
			this.support = (await  this.$http.get('/support/view/'+this.$route.params.id)).data.data;
			this.support.messages.reverse();
		},
		changeStatusToClosed() {
			this.support.status = 10;
		},
		terminateSupport() {
			this.closeSupport().then(() => {
				this.changeStatusToClosed();
			});
		}
	},
	async created() {
		await this.getSupport();
	},
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";

.Support-card{
	.align-center{
		align-items: center;
	}
	.messages{
		.message{
			width: 100%;
			.head{
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #c2c6dc;
				padding-bottom: 10px;
				flex-wrap: wrap;
				.name span{
					color: #ee6e57;
					text-transform: uppercase;
				}
			}
			.date{
				text-align: right;
				@media (max-width: 480px) {
					margin-top: 10px;
				}
			}
			.body{
				padding-top: 15px;
			}
			.files{
				display: flex;
				flex-wrap: wrap;
				.file{
					margin-right: 20px;
					display: flex;
					background-color: #e0e0e0;
					color: #212121de;
					width: 150px;
					align-items: center;
					border-radius: 38px;
					margin-bottom: 5px;
					.icon{
						width: 32px;
						border-radius: 100%;
						background-color: #0d47a1;
						height: 32px;
						display: flex;
						justify-content: center;
						align-items: center;
						flex-shrink: 0;
						margin-right: 10px;
						svg > path{
							&:last-child{
								fill: white;
							}
						}
					}
					.name{
						max-width: calc(100% - 55px);
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
			.image{
				width: 40px;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 100%;
				overflow: hidden;
				margin-right: 10px;
				img{
					max-width: 100%;
				}
			}
			&.manager{
				width: 97%;
				margin-left: auto;
				@media (max-width: 992px) {
					width: 100%;
				}
			}
		}
	}
}
.card-create-appeal {
	.con-input-upload, .img-upload {
		padding: 0;
		margin: 0;
	}

	.con-img-upload {
		padding: 0;
		margin-top: 16px;
	}

	.vs-con-input-label {
		width: 100%;
	}
	.vs-con-textarea{
		margin-bottom: 0px;
	}
}
.order__head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	.vs-button{
		@media (max-width: 992px) {
			margin: 10px 0;

		}
	}
	&-order {
		margin-right: 60px;
	}
}

.Support-card{
	.status {
		font-size: rem(14px);
		background-color: $primary;
		color: white;
		padding: 5px 10px;
		border-radius: 10px;

		&-ok {
			background-color: $success;
		}

		&-warn {
			background-color: $warning;
		}
		&-danger{
			background-color: $danger;
		}

	}
}

.terminate-popup {
	.vs-popup{
		max-width: 600px !important;
		width: 100% !important;
		padding: 0;

		&--content{
			width: 100%;
			height: 100%;
		}

		&--title {
			h3 {
				color: $warning;
			}
		}

		&--close {
			color: $warning;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}
}

.card-create-appeal {
	.img-upload,
	.con-input-upload {
		margin: 10px;
	}

	.con-img-upload {
		margin: 0 -10px -10px -10px;
	}
}
</style>
